import React, { memo } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import Main from '../../Main/Main';
import './styles.scss';
import { verificaMenuAberto, verificaTelaAberta } from '../../../services/authentication/auth';
import IconesMenu from '../../Shared/Enums/IconesMenu';
import useConfiguracoesHook from './useConfiguracoesHook';
import IframeComponent from './IframeComponent/IframeComponent';
import { DepartamentosEnum } from '../../Shared/Enums/DepartamentosEnum';

const Configuracoes = ({ escopoAcesso, setEscopoAcesso }) => {
  const {
    filtro,
    setFiltro,
    expanded,
    isPendingMenu,
    disableTooltip,
    menusFiltrados,
    handleSearch,
    handleKeyDown,
    handleKeyUp,
    handleChangeAccordion,
    scrIframeConfiguracoes,
    navegarTela,
    handleFavorito,
    loadingFavoritoId
  } = useConfiguracoesHook({ setEscopoAcesso });

  return (
    <Main
      title="Dashboard"
      className="tela-configuracoes"
      escopoAcesso={escopoAcesso}
      setEscopoAcesso={setEscopoAcesso}
    >
      <Box className="box-configuracoes">
        <Grid className="container-pricipal" container>
          <Grid item xl={2} lg={3} md={3} sm={12} xs={12} className="pad-5">
            <Box>
              <Typography variant="h5" className="cor-texto word-break texto-weight-600">
                Configurações
              </Typography>
            </Box>
            <Box>
              {isPendingMenu && (
                <Box className="box-loading">
                  <Stack className="pad-5" spacing={1}>
                    {[...Array(3)].map((_, index) => (
                      <React.Fragment key={index}>
                        <Skeleton variant="text" width="100%" height={70} />
                        <Skeleton variant="rectangular" width="100%" height={50} />
                      </React.Fragment>
                    ))}
                  </Stack>
                </Box>
              )}

              {!isPendingMenu && (
                <>
                  <Input
                    className="input-pesquisa"
                    type="text"
                    placeholder="Pesquisar por nome da página"
                    value={filtro}
                    onChange={e => setFiltro(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onKeyUp={handleKeyUp}
                    disableUnderline
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton onClick={handleSearch}>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Filtro"
                  />

                  <List className="box-lista-menu inferior">
                    {menusFiltrados.map(menu => (
                      <ListItem
                        key={menu.id}
                        className={`menu-list-itens ${isPendingMenu ? 'display-none' : ''}`}
                      >
                        {menu.subMenus && (
                          <Accordion
                            expanded={expanded === menu.id}
                            onChange={handleChangeAccordion(menu.id)}
                            className={`accordion-menu ${verificaMenuAberto(menu.id) ? 'active' : ''}`}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              id={`panel-header-${menu.id}`}
                              className="accordion-sumary"
                            >
                              <ListItemIcon>
                                <IconesMenu name={menu.icone} />
                              </ListItemIcon>
                              <ListItemText primary={menu.texto} />
                            </AccordionSummary>
                            <AccordionDetails className="accordion-details">
                              {menu.subMenus.map((subMenu, index) => (
                                <Box
                                  key={`${menu.id}_${subMenu.id}_${index}`}
                                  className={`itens-submenu ${verificaTelaAberta(subMenu.rota) ? 'active' : ''}`}
                                >
                                  <Grid container>
                                    <Grid
                                      className="pad-15 texto-icone"
                                      item
                                      xs={10}
                                      sm={10}
                                      md={10}
                                      lg={10}
                                      xl={10}
                                      onClick={() =>
                                        navegarTela(
                                          menu.id,
                                          subMenu.rota,
                                          subMenu.projeto,
                                          DepartamentosEnum.CONFIGURACOES
                                        )
                                      }
                                    >
                                      {subMenu.id} - {subMenu.texto}
                                    </Grid>
                                    <Grid className="pad-15" item xs={2} sm={2} md={2} lg={2} xl={2}>
                                      <Box
                                        className="texto-centro texto-icone"
                                        onClick={() =>
                                          handleFavorito(menu.id, subMenu.id, subMenu.favorito)
                                        }
                                      >
                                        {`${menu.id}_${subMenu.id}` === loadingFavoritoId ? (
                                          <StarOutlineIcon className="estrela-animando" size={20} />
                                        ) : (
                                          <>
                                            {subMenu.favorito && !disableTooltip && (
                                              <Tooltip title="Desmarcar como favorito">
                                                <StarIcon className="estrela-favorito" />
                                              </Tooltip>
                                            )}

                                            {!subMenu.favorito && !disableTooltip && (
                                              <Tooltip title="Marcar como favorito">
                                                <StarOutlineIcon />
                                              </Tooltip>
                                            )}

                                            {disableTooltip && subMenu.favorito && (
                                              <StarIcon className="estrela-favorito" />
                                            )}
                                            {disableTooltip && !subMenu.favorito && <StarOutlineIcon />}
                                          </>
                                        )}
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Box>
                              ))}
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </ListItem>
                    ))}

                    {menusFiltrados.length <= 0 && (
                      <Box className="nenhum-resultado-encontrado">
                        <Typography variant="body1" color="text.secondary">
                          Nenhum resultado encontrado para &quot;<b>{filtro}</b>&quot;.
                        </Typography>
                      </Box>
                    )}
                  </List>
                </>
              )}
            </Box>
          </Grid>
          <Grid item xl={10} lg={9} md={9} sm={12} xs={12}>
            <IframeComponent className="box-iframe" src={scrIframeConfiguracoes} />
          </Grid>
        </Grid>
      </Box>
    </Main>
  );
};

export default memo(Configuracoes);
